import { Pipe, PipeTransform } from '@angular/core';
import { IFilterTags } from '@shared/models/tag';

@Pipe({ name: 'parentTag', standalone: true })
export class ParentTagPipe implements PipeTransform {
  public transform(tags: IFilterTags[]): IFilterTags[] {
    return tags?.filter((tag) => tag.tag_group === 'category');
  }
}
